// Helper function to safely extract string from any value
export const getStringValue = (value: any): string => {
  if (value === null || value === undefined) return ""
  if (typeof value === "string") return value
  if (typeof value === "number" || typeof value === "boolean") return String(value)
  if (typeof value === "object") {
    // If it's an object with a text property
    if (value.text !== undefined) return getStringValue(value.text)
    // If it's an object with a value property
    if (value.value !== undefined) return getStringValue(value.value)
    // Otherwise try to stringify
    return String(value)
  }
  return ""
}

export const convertHtmlToArray = (html?: string) => {
  if (!html) return null

  const arr = Array.from(html.matchAll(/<[^>]+>(.*?)<\/[^>]+>/g)).map(m => m[1].trim())
  return arr
}

export const parseElevation = (elevation?: string) => {
  if (!elevation || (elevation && elevation.trim() === "")) return ""

  // Regex để tìm các elevation values (có thể có dấu +/-, số với dấu phẩy, và đơn vị M)
  const elevationRegex = /[+-]?\s*\d{1,3}(?:,\d{3})*\s*M/g
  const matches = elevation.match(elevationRegex)

  if (matches) {
    // Clean up và format lại thành HTML
    return matches
      .map(match => match.trim())
      .filter(match => match !== "")
      .slice(0, 2)
      .map(elevation => `<p>${elevation}</p>`)
      .join("")
  }

  // Fallback: nếu regex không match, dùng cách cũ
  const parts = elevation
    .split(/(?<=\d{3}M)\s*,\s*(?=[+-])/) // Split chỉ khi có pattern "sốM, +" hoặc "sốM, -"
    .map(item => item.trim())
    .filter(item => item !== "")

  return parts
    .slice(0, 2)
    .map(elevation => `<p>${elevation}</p>`)
    .join("")
}
